<template>
  <div class="">
    <div class="body-main">


      <div class="order-main clearfix">


        <div class="slider l">
          <h1>当前积分：{{integration}}</h1>
          <ul class="nav-menu">
            <a href="javascript:void(0);">
              <li class="clearfix" @click="click('order')" :class="{active: redActive=='order'}">
                <p class="nav-name l">我的订单</p>
<!--                <span class="imv2-arrow1_r r"></span>-->
                <i class="el-icon-caret-left r imv2-arrow1_r"></i>
              </li>
            </a>
            <a href="javascript:void(0);">
              <li class="clearfix" @click="click('upload')" :class="{active: redActive=='upload'}">
                <p class="nav-name l">上传稿件</p>
                <!--                <span class="imv2-arrow1_r r"></span>-->
                <i class="el-icon-caret-left r imv2-arrow1_r"></i>
              </li>
            </a>
            <a href="javascript:void(0);">
              <li class="clearfix" @click="click('content')" :class="{active: redActive=='content'}">
                <p class="nav-name l">内容管理</p>
                <!--                <span class="imv2-arrow1_r r"></span>-->
                <i class="el-icon-caret-left r imv2-arrow1_r"></i>
              </li>
            </a>

          </ul>
        </div><!-- .slider end -->

<!--        订单中心 开始-->
        <div class="right-container l" v-if="this.model=='order'">
          <div class="right-title">
            <h2>我的订单</h2>
            <ul>
              <li :class="{action:title[0].where}" @click="getOrderByState(0)"><a href="javascript:void(0);">全部<i class="js-all-num">({{this.orderNum}})</i></a></li>
              <li :class="{action:title[1].where}" @click="getOrderByState(1)"><a href="javascript:void(0);">未支付</a></li>
              <li :class="{action:title[2].where}" @click="getOrderByState(2)"><a href="javascript:void(0);">已完成</a></li>
<!--              <li :class="{action:title[3].where}" @click="getOrderByState(3)"><a href="javascript:void(0);">已失效</a></li>-->
            </ul>
            <span :class="{action:title[3].where}" @click="getOrderByState(3)"><a href="javascript:void(0);"><i class="imv2-delete el-icon-delete-solid"></i> 订单回收站</a></span>
          </div>


          <div class="myOrder">


            <ul class="myOrder-list">


              <li v-for="order in this.orderInfo">
                <p class="myOrder-number">
                  <i class="imv2-receipt el-icon-s-order"></i>订单编号：{{order.orderNum}}
                  <span class="date">{{order.createTime}}</span>
                  <i v-if="order.orderStatus=='10'" class="imv2-delete js-order-del el-icon-delete-solid" @click="deleteOrder(order.orderNum)"  title="删除订单"></i>
                  <a href="" target="_blank" class="myfeedback r">
                    <router-link v-if="order.orderStatus=='20'" :to="{name:'VideoDetail', params: {id:order.productId}}">
                      去学习
                    </router-link>
                    <router-link v-if="order.orderStatus=='10'" :to="{name:'Pay', params: {id:order.orderNum}}">
                      去支付
                    </router-link>
                  </a>
                </p>

                <div class="myOrder-course clearfix">
                  <dl class="course-del l">
                    <dd class="clearfix">
                      <a href="javascript:void(0);" @click="goStudy(order.orderStatus,order.productId,order.type)"  class="l">
                        <img class="l" :src="baseUrl+order.picUrl" width="160"
                             height="90">
                      </a>
                      <div class="del-box l">
                        <!-- type为类型 1实战购买 2实战续费 4就业班购买 5就业班续费 -->

                        <a href="javascript:void(0);" @click="goStudy(order.orderStatus,order.productId,order.type)"><p class="course-name">
                          {{order.title}}</p></a>

                        <p class="price-btn-box clearfix">
                          <!-- 如果有优惠券 -->
                          <span v-if="order.orderStatus=='20'" class="l truepay-text">实付</span>
                          <span v-if="order.orderStatus=='10'" class="l truepay-text">待付</span>
                          <span class="l course-little-price">￥{{order.orderAmount}}</span>
                        </p>
                      </div>
                    </dd>
                  </dl>
                  <!-- 使用优惠券 -->
                  <div class="course-money l pt15">
                    <div class="type-box clearfix mb10">
                      <p class="type-text l">原价</p>
                      <p class="type-price l line-though">
                        <span class="RMB">¥</span>
                        {{order.orderAmount}}
                      </p>
                    </div>
                    <div class="type-box clearfix mb10">
                      <p class="type-text l">折扣</p>
                      <p class="type-price l">
                        -
                        <span class="RMB">¥</span>
                        0.00
                      </p>
                    </div>
                    <div class="total-box clearfix">
                      <p v-if="order.orderStatus=='20'" class="type-text l">实付</p>
                      <p v-if="order.orderStatus=='10'" class="type-text l">待付</p>
<!--                      <p  class="type-text l">待付</p>-->
                      <p class="type-price l">
                        <span class="RMB">¥</span>
                        {{order.orderAmount}}
                      </p>
                    </div>

                  </div>


                  <div class="course-action l">
                    <p v-if="order.orderStatus=='20'" class="order-close">
                      已支付
                    </p>
                    <p v-if="order.orderStatus=='10'" class="order-close">
                      待支付
                    </p>
                    <p v-if="order.orderStatus=='30'" class="order-close">
                      已删除
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

        </div>
<!--        订单中心 结束-->
<!--        上传稿件 开始-->
        <div class="right-container l" v-if="this.model=='upload'">
          <div class="right-title">
            <h2>上传稿件</h2>
          </div>


          <div class="myOrder">
            <el-steps :active="active" align-center>
              <el-step title="选择稿件类型" description=""></el-step>
              <el-step title="填写稿件信息" description=""></el-step>
              <el-step title="上传文件信息" description=""></el-step>
              <el-step title="完成稿件" description=""></el-step>
            </el-steps>

            <div class="upload-file-type" v-if="active == 1">
              <el-radio v-model="info.type" label="1" border>视频稿件</el-radio>
              <el-radio v-model="info.type" label="2" border>文章稿件</el-radio>


            </div>

            <el-form :model="info" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <div class="upload-base-info" v-if="active == 2">

                <el-form-item label="稿件标题：" prop="title">
                  <el-input v-model="info.title"></el-input>
                </el-form-item>
                <el-form-item label="稿件简介：" prop="description">
                  <el-input v-model="info.description" type="textarea"></el-input>
                </el-form-item>

            </div>
            <div class="upload-file-info upload-base-info" :class="{contentTinymce: info.type=='2'}" v-if="active == 3">

                <el-form-item label="稿件封面图：">
                  <el-upload
                    :action="this.myAction"
                    list-type="picture-card"
                    limit= 1
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :data="info.param"
                    :file-list="fileList"
                    :on-success="handleThisSuccess">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="info.dialogVisible">
                    <img width="100%" :src="info.baseUrl + info.picUrl" alt="">
                  </el-dialog>
                </el-form-item>
              <el-form-item label="稿件内容：" v-if="info.type=='2'" class="">
                <tinymce v-model="info.content" :height="300" />
              </el-form-item>
                <el-form-item label="视频上传：" v-if="info.type=='1'">
                  <el-upload
                    class="upload-demo"
                    drag
                    :action="this.myAction"
                    limit=1
                    multiple="false"
                    :on-preview="handleVideoPictureCardPreview"
                    :on-remove="handleVideoRemove"
                    :data="info.param"
                    :on-success="handleVideoThisSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="info.url != ''">
                  <video id="videoBarrage" class="videoBarrage" :src="info.baseUrl+info.url" controls="controls"></video>
                </el-form-item>

            </div>
            </el-form>
            <div class="upload-file-complete" v-if="active == 4">
              <div class="tip">
                <p>点击下方“完成创建”按钮完成创建，请耐心等待审核。</p>
              </div>
              <div>
                <el-checkbox v-model="readed">已阅读</el-checkbox>
                <router-link tag="a"
                             target="_blank"
                             :to="{ name: 'FileRule' }">
                  <el-link type="primary" >百驿学院相关规则</el-link>
                </router-link>

              </div>
            </div>
            <div class="step-button">
              <el-row>
                <el-button v-if="active>1" type="info"  @click="last">上一步</el-button>
                <el-button v-if="active<4" type="info"  @click="next">下一步</el-button>
                <el-button v-if="active == 4" type="info"  @click="upload()">完成创建</el-button>
              </el-row>
            </div>
          </div>

        </div>
        <!--      上传稿件 结束-->
        <!--内容管理 开始-->
        <div class="right-container l" v-if="this.model=='content'">
          <div class="right-title">
            <h2>内容管理</h2>
            <ul>
              <li :class="{action:content[0].where}" @click="getUserContentByState(0)"><a href="javascript:void(0);">全部<i class="js-all-num">({{this.userContentCount}})</i></a></li>
              <li :class="{action:content[1].where}" @click="getUserContentByState(1)"><a href="javascript:void(0);">审核通过</a></li>
              <li :class="{action:content[2].where}" @click="getUserContentByState(2)"><a href="javascript:void(0);">审核中</a></li>
                            <li :class="{action:content[3].where}" @click="getUserContentByState(3)"><a href="javascript:void(0);">审核失败</a></li>
            </ul>
<!--            <span :class="{action:title[3].where}" @click="getOrderByState(3)"><a href="javascript:void(0);"><i class="imv2-delete el-icon-delete-solid"></i> 订单回收站</a></span>-->
          </div>


          <div class="myOrder">


            <ul class="myOrder-list">


              <li v-for="order in this.userContent">
                <p class="myOrder-number">
                  <i class="imv2-receipt el-icon-s-order"></i>
                  <span v-if="order.type==2">
                     类别：文稿
                  </span>
                  <span v-if="order.type==1">
                     类别：视频
                  </span>
<!--                  类别：{{order.orderNum}}-->
                  <span class="date">创建时间：{{order.uploadTime}}</span>
<!--                  <i v-if="order.orderStatus=='10'" class="imv2-delete js-order-del el-icon-delete-solid" @click="deleteOrder(order.orderNum)"  title="删除订单"></i>-->
                  <a href="" target="_blank" class="myfeedback r">
                    <router-link v-if="order.status=='1'" :to="{name:'VideoDetail', params: {id:order.id}}">
                      去学习
                    </router-link>
                  </a>
                </p>

                <div class="myOrder-course clearfix">
                  <dl class="course-del l dec">
                    <dd class="clearfix">
                      <a href="javascript:void(0);" @click="goStudy(order.status,order.id,order.type)"  class="l">
                        <img class="l" :src="info.baseUrl+order.picUrl" width="160"
                             height="90">
                      </a>
                      <div class="del-box l content-dec">
                        <!-- type为类型 1实战购买 2实战续费 4就业班购买 5就业班续费 -->

                        <a href="javascript:void(0);" @click="goStudy(order.status,order.id,order.type)"><p class="course-name">
                          {{order.title}}</p></a>

                        <p class="price-btn-box clearfix">
                          <!-- 如果有优惠券 -->
                          <span class="l truepay-text">
                             {{order.description}}
                          </span>

                        </p>
                      </div>
                    </dd>
                  </dl>


                  <div class="course-action l">
                    <p v-if="order.status=='1'" class="order-close success">
                      审核通过
                    </p>
                    <p v-if="order.status=='0'" class="order-close wait">
                      审核中...
                    </p>
                    <p v-if="order.status=='2'" class="order-close failure">
                      审核失败
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>




      <!-- 专栏海报模板 -->


    </div>
  </div>
</template>

<script>
  import {getOrderInfoByState,deleteOrder} from "@/api/order"
  import {insertFile,getUserFile} from "@/api/userFile"
  import Tinymce from '@/components/Tinymce'
  import store from '@/store'
  import GLOBAL from '@/utils/global_variable'
    export default {
        name: "orderCenter",
      components:{ Tinymce },
      data(){
          return{
              myAction: this.baseBackUrl+'video/uploadFile?access_token='+store.getters.token,
              fileList: [],
            active: 1,
            readed:false,
            model:'order',
            integration:'',
            title:[
              {where: true},
              {where: null},
              {where: null},
              {where: null}
            ],
            content:[
              {where: true},
              {where: null},
              {where: null},
              {where: null}
            ],
            orderNum: null,
            orderInfo: [],
            pic: this.baseUrl,
            info:{
                title: '',
                description:'',
                type: '1',
                ifCharge:0,
                dialogImageUrl: '',
                dialogVisible: false,
                dialogAvatarUrl: '',
                dialogVisibleAvatar: false,
                param:'',
                baseUrl: GLOBAL.baseURL,
                picUrl:'',
                url:'',
                content:''
            },
            redActive:'order',
            userContent:{

            },
            userContentCount:'',
              rules:{
                  title: [
                      { required: true, message: '请输入稿件标题', trigger: 'blur' }
                  ],
                  description: [
                      { required: true, message: '请输入视频简介', trigger: 'blur' }
                  ],
              }
          }
      },
      created(){
        this.getOrderInfo();
        // this.getUserFile(null);
      },
      methods:{
        goFileRule(){

        },
          getUserFile(status){
            getUserFile(status).then(res=>{
              if (res.code==20000){
               this.userContent = res.data.userContent
               this.userContentCount = res.data.userContentCount
              }
            })
          },
          upload(){
              if(this.readed==false){
                this.$message({
                  message: '请查看百驿学院相关规则',
                  type: 'warning'
                });
                return;
              }
              if (this.info.title==''){
                  this.$message({
                      message: '请输入标题',
                      type: 'warning'
                  });
                  return
              }
              if (this.info.type=='1'){
                if (this.info.url==''){
                  this.$message({
                    message: '请输入视频',
                    type: 'warning'
                  });
                  return
                }
              }
              if(this.info.type=='2'){
                if (this.info.content==''){
                  this.$message({
                    message: '请输入文稿',
                    type: 'warning'
                  });
                  return
                }
              }
              if (this.info.picUrl==''){
                  this.$message({
                      message: '请输入封面',
                      type: 'warning'
                  });
                  return
              }
              insertFile(this.info).then( res=>{
                  if ( res.code==20000 ) {
                          this.$message({
                              message: '稿件创建成功',
                              type: 'success'
                          });
                    this.$router.go(0);
                  }
              })
          },
          handleVideoPictureCardPreview(file) {
              this.info.dialogImageUrl = this.info.baseUrl + file.response.data
          },
          handleVideoRemove(file, fileList) {
              this.info.url = ''
          },
          handleVideoThisSuccess(response, file, fileList) {
              this.info.url = response.data
          },
          handlePictureCardPreview(file) {
              // this.form.dialogImageUrl = this.form.baseUrl + file.response.data
              this.info.dialogImageUrl = file.url
              this.info.dialogVisible = true
          },
          handleThisSuccess(response, file, fileList) {
              this.info.picUrl = response.data
          },
          handleRemove(file, fileList) {
              this.info.picUrl = ''
          },
          next() {
              // if (this.active++ > 2) this.active = 0;
              this.active++
          },
          last() {
              this.active--
          },
        click(param){
              this.model=param
          if (param=='content') {
            this.getUserFile(null)
          }
         this.redActive=param
        },
        getOrderByState(num){
          for (let i = 0; i < 4; i++) {
            if (i === num){
              this.title[num].where=true
              continue
            }
            this.title[i].where=null
          }
          if (num === 0){
            this.getOrderInfo()
          } else if(num === 1){
            this.getOrderInfo(10)
          }else if(num === 2){
            this.getOrderInfo(20)
          }else if(num === 3){
            this.getOrderInfo(30)
          }
        },
        getUserContentByState(num){
          for (let i = 0; i < 4; i++) {
            if (i === num){
              this.content[num].where=true
              continue
            }
            this.content[i].where=null
          }
          if (num === 0){
            this.getUserFile(null)
          } else if(num === 1){
            this.getUserFile(1)
          }else if(num === 2){
            this.getUserFile(0)
          }else if(num === 3){
            this.getUserFile(2)
          }
        },

        getOrderInfo(state){
          getOrderInfoByState(state).then(res => {
            this.orderNum = res.data.count
            this.orderInfo = res.data.orderInfo
            this.integration= res.data.integration
          })
        },
        deleteOrder(orderNum){
          this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteOrder(orderNum).then(res=>{
              if (res.code==20000) {
                this.$notify({
                  title: '成功',
                  message: '删除成功',
                  type: 'success'
                });
                this.$router.push({name:'SelfOrders'})
              }
            })

          }).catch(() => {
            this.$notify({
              title: '提示',
              message: '已取消删除',
              type: 'info'
            });
          });

        },
        goStudy(status,id,type){
          if(status=='20' && type===1){
            this.$router.push({name:'VideoDetail', params: {id:id}})
          }else if(status=='20' && type===2){
            this.$router.push({name:'Article', params: {id:id}})
          }
          else if(status=='1' && type===1){
            this.$router.push({name:'VideoDetail', params: {id:id}})
          }else if(status=='1' && type===2){
            this.$router.push({name:'Article', params: {id:id}})
          }
        }

      }
    }
</script>

<style scoped>
  /*@import "https://order.imooc.com/static/module/??common/css/common-less.css?v=2.0,pay/common/css/common-less.css,common/css/left_nav-less.css,pay/myorder/css/index-less.css?v=1569566881";*/
  @import "../../assets/order/order.css";
  @import "../../assets/order/upload.css";
  .body-main {
    min-height: 750px;
    background: #fff;
    color: #5e5e5e;
    font: 14px/2em "PingFang SC","微软雅黑","Microsoft YaHei",Helvetica,"Helvetica Neue",Tahoma,Arial,sans-serif;
  }
  blockquote, body, button, code, dd, div, dl, dt, fieldset, form, h1, h2, h3, h4, h5, h6, input, legend, li, ol, p, pre, td, textarea, th, ul {
    margin: 0;
    padding: 0;
  }
  .el-link.el-link--primary {
    color: #409EFF;
  }

</style>



// WEBPACK FOOTER //
// src/views/selforders/orderCenter.vue